export default "__VITE_ASSET__CsMfHfRP__"